import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../Univ";
import { DataGrid, GridToolbar, GridPagination } from "@mui/x-data-grid";
import { MenuItem, Select } from "@mui/material";
import Swal from "sweetalert2";
function SellerOrders() {
  const [orders, setOrders] = useState([]);

  // -------------------------
  // FETCH ORDERS
  // -------------------------
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    const res = await axios.get(baseUrl + "seller-orders/", {
      headers: { Authorization: `Bearer ${localStorage.getItem("access")}` },
    });

    // Flatten orders for grid
    const rows = res.data.map((order) => ({
      id: order.id,
      order_id: order.id,
      date: order.created_at,
      status: order.status,
      del_status: order.del_status,
      total: order.total_amount,
      items: order.items,
    }));

    setOrders(rows);
  };

  // -------------------------
  // UPDATE STATUS
  // -------------------------
  const updateStatus = async (id, status) => {
    await axios.post(
      baseUrl + "update-order-status/",
      { id, status },
      { headers: { Authorization: `Bearer ${localStorage.getItem("access")}` } }
    );
          Swal.fire({
        title: "Product Updated Successfully",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });


  };

  // -------------------------
  // COLUMNS
  // -------------------------
  const columns = [
    { field: "order_id", headerName: "Order ID", width: 80 },
    { field: "date", headerName: "Date", width: 150 },
    { field: "status", headerName: "Status", width: 130 },
    {
      field: "items",
      headerName: "Products",
      flex: 1,
      width: 380,
      renderCell: (params) => (
        <div>
          {params.value.map((i) => (
            <div key={i.id}>
              {i.product.name} - Qty {i.quantity}
            </div>
          ))}
        </div>
      ),
    },
    { field: "total", headerName: "Total Amount", width: 80 },
{
  field: "update_status",
  headerName: "Update Status",
  width: 250,
  renderCell: (params) => {

    const statusMap = {
      pending: "Pending",
      processing: "Processing",
      shipped: "Shipped",
      delivered: "Delivered",
    };

    // lowercase key mapping
    const currentStatus = params.row.del_status?.toLowerCase() || "pending";

    return (
      <Select
        value={currentStatus}
        onChange={(e) => updateStatus(params.row.id, e.target.value)}
        size="small"
        fullWidth
      >
        {Object.entries(statusMap).map(([value, label]) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    );
  },
},


  ];

  // -------------------------
  // UI
  // -------------------------
  return (
    <div className="container mt-4">
      <h3>Orders For My Products</h3>

      <DataGrid
        sx={{
          boxShadow: 4,
          border: 2,
          borderColor: "primary.light",
          "& .MuiDataGrid-cell:hover": {
            color: "primary.main",
          },
        }}
        rows={orders}
        columns={columns}
        pageSizeOptions={[10, 25, 50, 100]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10, page: 0 } },
        }}
        slots={{ toolbar: GridToolbar, Pagination: GridPagination }}
        autoHeight
      />
    </div>
  );
}

export default SellerOrders;
